function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.46 283.46"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Youtube"
}, /*#__PURE__*/React.createElement("path", {
  d: "M277.541 73.061c-3.26-12.275-12.865-21.943-25.06-25.224-22.107-5.962-110.749-5.962-110.749-5.962s-88.641 0-110.748 5.962c-12.196 3.281-21.8 12.949-25.06 25.224C0 95.311 0 141.732 0 141.732s0 46.422 5.923 68.672c3.26 12.275 12.866 21.942 25.061 25.223 22.107 5.962 110.748 5.962 110.748 5.962s88.642 0 110.748-5.962c12.196-3.28 21.801-12.948 25.061-25.223 5.923-22.25 5.923-68.672 5.923-68.672s0-46.421-5.923-68.67z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M112.742 183.88V99.585l74.087 42.149z"
}))));